var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFileDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Regular/Outline/Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 16.5414C11.587 16.5414 11.251 16.2054 11.251 15.7914V3.75037C11.251 3.33637 11.587 3.00037 12.001 3.00037C12.415 3.00037 12.751 3.33637 12.751 3.75037V15.7914C12.751 16.2054 12.415 16.5414 12.001 16.5414Z",
    fill: "#096DD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 16.5413C11.8018 16.5413 11.6098 16.4623 11.4698 16.3203L8.55383 13.3933C8.26183 13.0993 8.26283 12.6243 8.55583 12.3323C8.84983 12.0403 9.32383 12.0403 9.61583 12.3343L12.0008 14.7293L14.3858 12.3343C14.6778 12.0403 15.1518 12.0403 15.4458 12.3323C15.7388 12.6243 15.7398 13.0993 15.4478 13.3933L12.5318 16.3203C12.3918 16.4623 12.1998 16.5413 12.0008 16.5413Z",
    fill: "#096DD9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1050_30711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 20,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.73285H21.9998V21.4768H2V7.73285Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1050_30711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.575 21.4768H6.435C3.99 21.4768 2 19.4878 2 17.0418V12.1568C2 9.71685 3.985 7.73285 6.426 7.73285H7.367C7.781 7.73285 8.117 8.06885 8.117 8.48285C8.117 8.89685 7.781 9.23285 7.367 9.23285H6.426C4.812 9.23285 3.5 10.5438 3.5 12.1568V17.0418C3.5 18.6608 4.816 19.9768 6.435 19.9768H17.575C19.187 19.9768 20.5 18.6638 20.5 17.0518V12.1678C20.5 10.5488 19.183 9.23285 17.566 9.23285H16.634C16.22 9.23285 15.884 8.89685 15.884 8.48285C15.884 8.06885 16.22 7.73285 16.634 7.73285H17.566C20.011 7.73285 22 9.72285 22 12.1678V17.0518C22 19.4918 20.014 21.4768 17.575 21.4768Z",
    fill: "#096DD9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDownload);
export default __webpack_public_path__ + "static/media/icon-file-download.6645608b60ddfa84223c5095e535a6e3.svg";
export { ForwardRef as ReactComponent };